import Store from '../vuex/store';
import {create_historical_data} from '@/base/base';

export default class Person_base {
  constructor(Vue) {
    let that = this;
    this.p_$nextTick = Vue.prototype.$nextTick;
    this.p_$forceUpdate = Vue.prototype.$forceUpdate;
    //屏幕宽度
    this.screenWidth = document.documentElement.clientWidth || document.body.clientWidth;

    //屏幕高度
    this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;

    this.p_$message = Vue.prototype.$message;
    this.p_$confirm = Vue.prototype.$confirm;
    this.p_$set = Vue.prototype.$set;


  }

  //找到row的索引
  /*
   id:row的id
   type:放置在body、header或footer
   返回row 的索引
  * */
  p_find_rowIndex({id, type}) {
    let index = 0;
    let list = [];
    let rowId = id;
    if (type == 'body') {
      list = Store.state.myRender.body;
    } else if (type == 'header') {
      list = Store.state.myRender.header;
    } else {
      list = Store.state.myRender.footer;
    }

    for (let i = 0; i < list.length; i++) {
      if (rowId == list[i].widgets_id) {
        index = i;
        break;
      }
    }
    return index;

  }

  /*
  * 找col
  * */
  p_find_colIndex({pid, type, id}) {
    let index = 0;
    let list = [];
    let colId = id;
    const rowIndex = this.p_find_rowIndex({
      id: pid,
      type
    });

    if (type == 'body') {
      list = Store.state.myRender.body[rowIndex].children;
    } else if (type == 'header') {
      list = Store.state.myRender.header[rowIndex].children;
    } else {
      list = Store.state.myRender.footer[rowIndex].children;
    }


    for (let i = 0; i < list.length; i++) {
      if (colId == list[i].widgets_id) {
        index = i;
        break;
      }
    }
    return {
      row: rowIndex,
      col: index
    };
  }

  //用id递归找到目标,返回搜索目标的所有信息
  find_obj(id, all = ['header', 'body', 'footer', 'full_screen_banner', 'common.full_screen_banner']) {
    // console.log('find_obj');
    let obj = null;
    for (let i = 0; i < all.length; i++) {
      let list = [];
      if (all[i].indexOf('.') > -1) {
        list = Store.state.myRender[all[i].split('.')[0]][all[i].split('.')[1]];
      } else {
        list = Store.state.myRender[all[i]];
      }

      obj = this.find_obj_make(list, id, {
        rowType: all[i],
        row_id: '',
        col_id: '',
        module_id: '',
        row_index: -1,
        col_index: -1,
        module_index: -1,
        row_2_index: -1,
        col_2_index: -1
      });

      this.setLevel2Index(obj, list)

      if (obj) break;
    }
    if (obj) {
      return obj;
    } else {
      return null;
    }

  }

  find_obj_make(list, id, data) {
    let obj = null;
    for (let i = 0; i < list.length; i++) {
      const now_obj = list[i];

      //记录选中的那个的索引
      if (list[i].name === 'layout_row' && list[i].newType !== 'row2') {
        if (data.row_id == '') {
          //初始化赋值
          data.row_id = list[i].widgets_id;
        }
        //换row了，要把colindex清空
        if (list[i].widgets_id != data.row_id) {
          data.col_index = -1;
          data.module_index = -1;
          data.row_id = list[i].widgets_id;
        }
        data.row_index++;
      } else if (list[i].name === 'layout_column' && list[i].newType !== 'col2') {
        if (data.col_id == '') {
          data.col_id = list[i].widgets_id;
        }
        //换col了，要把moduleindex清空
        if (list[i].widgets_id != data.col_id) {
          data.module_index = -1;
          data.col_id = list[i].widgets_id;
        }
        data.col_index++;
      } else if (list[i].newType === 'row2') {
        data.module_index = -1;
      } else if (list[i].newType === 'col2') {
        data.module_index = -1;
      } else {
        data.module_id = list[i].widgets_id;
        data.module_index++;
      }

      if (now_obj.widgets_id == id) {
        obj = {
          ...data,
          target: now_obj
        }
      } else if (now_obj.children && now_obj.children instanceof Array) {
        if (now_obj.name === 'basic_row_tab') {
          let findObj = null
          now_obj.children.forEach((col, tabIndex) => {
            col.columnType = 'tabPanel'
            col.row_idnex = data.row_index
            col.col_index = data.col_index
            col.tab_index = tabIndex

            if (String(col.widgets_id) === String(id)) {
              findObj = Object.assign({}, col)
              findObj.target = col
            }
            col.children.forEach((module, index) => {
              module.row_idnex = data.row_index
              module.col_index = data.col_index
              module.module_index = data.module_index
              module.tab_index = tabIndex
              module.tab_module_index = index
              if (String(module.widgets_id) === String(id)) {
                findObj = Object.assign({}, module)
                findObj.target = module
                findObj.isTabModule = true
              }
            })
          })
          if (findObj) {
            return findObj
          }
        } else {
          //如果返回有结果 则停止循环
          obj = this.find_obj_make(now_obj.children, id, data);
        }
      }
      if (obj) break;
    }
    if (obj) return obj;

  }

  setLevel2Index(obj, list) {
    if (!obj) {
      return
    }
    list.forEach(row_1 => {
      if (row_1.isNewRow) {
        row_1.children.forEach((col_1) => {
          col_1.children.forEach((row_2, row_2_index) => {
            if (row_2.isNewRow) {
              (row_2.children || []).forEach((col_2, col_2_index) => {
                if (col_2.newType === 'col2') {
                  let hasTarget = col_2.children.some(m => {
                    if (m.name !== 'basic_row_tab') {
                      return String(m.widgets_id) === String(obj.module_id || obj.widgets_id)
                    } else {
                      return (m.children || []).some(tabPanel => {
                        return (tabPanel.children || []).some((module) => {
                          return String(module.widgets_id) === String(obj.module_id || obj.widgets_id)
                        })
                      })
                    }

                  })
                  if (hasTarget) {
                    obj.isModuleInNewLayout = true
                    obj.row_2_index = row_2_index
                    obj.col_2_index = col_2_index
                  }
                }
              })
            }
          })
        })
      }
    })
  }

  //返回中文名
  return_c_name(name) {
    let c_name = name;
    const obj = Store.state.left_sidebar.PendantObj[name];
    if (obj) {
      c_name = obj.title;
    }
    return c_name;
  }

  //挂件中的加入历史记录
  module_add_historical(title = 'change') {
    if (Store.state.historical.websql_debounce != null) {
      Store.commit('historical/set_edit_module_name', title);
      Store.state.historical.websql_debounce();
      Store.commit('app/historyChange', true)
    } else {
      //this.firefox_historical_add();


    }
  }

  firefox_historical_add() {
    const one = create_historical_data(Store.state);
    const firefox_historical = Store.state.historical.firefox_historical;
    if (firefox_historical.length >= 20) {
      firefox_historical.shift();
    }
    Store.state.historical.firefox_historical.push(one);
    Store.state.historical.firefox_Pointer_index = firefox_historical.length;
    console.log(Store.state.historical.firefox_historical)

  }


}



// WEBPACK FOOTER //
// ./src/base/row.js